import React, { useRef, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useDrag } from 'react-use-gesture'
import { directstyled, useDirectStyle } from 'direct-styled'
import { setAudioData } from '../../../../modules/audio/actions'
import c from 'classnames'

const formatTime = seconds => {
  return [Math.floor(seconds / 60), Math.floor(seconds % 60)]
    .map(x => x.toString())
    .map(x => (x.length === 1 ? `0${x}` : x))
    .join(':')
}

const minMax = (min, max, value) => {
  if (value > max) {
    return max
  }
  if (value < min) {
    return min
  }
  return value
}

const getNewTimeProps = (barRect, clientX, duration) => {
  const seconds = minMax(
    0,
    duration,
    Math.floor(((clientX - barRect.left) / barRect.width) * duration),
  )

  const progress = (seconds / duration) * 100

  return { seconds, progress }
}

const TimeBar = ({
  style,
  className,
  duration,
  progress,
  currentTime,
  isSeeking,
  setTime,
  playAudio,
  audio,
}) => {
  const barRef = useRef(null)
  const { audioState } = useSelector(({ audio }) => audio)
  const [barStyle, setBarStyle] = useDirectStyle()
  const [circleStyle, setCircleStyle] = useDirectStyle()
  const [ignoreTimeUpdates, setIgnoreTimeUpdates] = useState(false)
  const dispatch = useDispatch()
  const [avtor, setAvtor] = useState(false)

  useEffect(() => {
    if (audio === audioState?.src) {
      setAvtor(true)
    } else {
      setAvtor(false)
    }
  }, [audio, audioState])

  const setStyles = progress => {
    setCircleStyle({
      left: `${progress}%`,
    })

    setBarStyle({
      background: audioState?.status ? `linear-gradient(to right, #D56BEF 0%, #D56BEF ${progress}%, #f6e1fb ${progress}%, #f6e1fb 100%)` : `linear-gradient(to right, #FE794E 0%, #FE794E ${progress}%, #F9BAA6 ${progress}%, #F9BAA6 100%)`,
    })
  }

  const bind = useDrag(
    ({ xy, first, last, event }) => {
      event.preventDefault()

      if (first) {
        setIgnoreTimeUpdates(true)
      }

      const { seconds, progress } = getNewTimeProps(
        barRef.current.getBoundingClientRect(),
        xy[0],
        duration,
      )

      if (last) {
        dispatch(setAudioData({ ...audioState, newTime: seconds }))
        setTime(seconds)
        setIgnoreTimeUpdates(false)
        return
      }

      setStyles(progress)
    },
    { event: { passive: false, capture: true } },
  )

  useEffect(() => {
    if (ignoreTimeUpdates) {
      return
    }

    setStyles(audioState?.time / duration * 100)
  }, [audioState])

  return (
    avtor ? (
      <div
        className={`timebar ${className || ''}`}
        style={{ ...style }}
      >
        <directstyled.div ref={barRef} className={c('timebar-bar-item', !audioState?.status && 'timebar-bar-item-stop')} style={barStyle}>
          <directstyled.div
            {...bind()}
            className={c('timebar-circle', audioState?.status && 'timebar-circle-active')}
            style={circleStyle}
          />
        </directstyled.div>
        <div className='timeBox'><span className='startTime'>{formatTime(audioState?.time)} / </span><span className='fullTime'>{formatTime(duration)}</span></div>
      </div>
    ) : (
      <div className='defaultProgress'>
        <div className='defaultProgressItem'>
          <div className='defaultProgressCircle' />
        </div>
        <div className='timeBox'><span className='startTime'>00:00 / </span><span className='fullTime'>{formatTime(duration)}</span></div>
      </div>
    )
  )
}

export default TimeBar
